/* istanbul ignore next: as this is just talking to the window API */
export class SubWindow {
  public close() {
    window.close();
  }
}
